import {Heading, Box, Link, useDisclosure} from '@chakra-ui/react';
import Page from '../../components/Page/Page';
import {Link as RouterLink} from 'react-router-dom';
import {TableControls} from '../../components/TableControls/TableControls';
import {YCTable} from '../../components/YCTable/YCTable';
import {useEventContext} from '../../contexts/EventContext';
import {skipToken} from '@reduxjs/toolkit/query/react';
import Card from 'components/Card/Card';
import {useGetSubEventsForEventQuery} from '../../app/api';
import {DateTimeInput} from '../../components/DateTimeInput';
import CreateSubEventModal from './CreateSubEventModal';

const columns = [
  {
    Header: 'Title',
    accessor: 'title',
  },
  {
    Header: 'Description',
    accessor: 'description',
  },
  {
    Header: 'Time',
    accessor: 'time',
    Cell: ({value}: { value: Date }) => (<DateTimeInput isDisabled={true} date={value}/>)
  },
  {
    Header: 'Actions',
    accessor: 'id',
    Cell: ({value}: { value: string }) => (
      <Link color="blue.500" as={RouterLink} to={`${value}`}>
        View
      </Link>
    ),
  },
];

const SubEvents = ({}) => {
  const {currentEvent} = useEventContext();
  const {data, refetch} = useGetSubEventsForEventQuery(
    currentEvent?.id ?? skipToken
  );
  const {isOpen, onOpen, onClose} = useDisclosure();

  return (
    <>
      <Page flexDir="row" display="flex">
        <Box padding={5} flexGrow={1} overflow="auto">
          <Card>
            <Heading>Sub-Events</Heading>
            <TableControls addAction={onOpen}/>
          </Card>
          <Card mt={2}>
            <YCTable columns={columns} data={data || []}/>
          </Card>
        </Box>
      </Page>
      <CreateSubEventModal isOpen={isOpen} onOpen={onOpen} onClose={onClose} afterSubmit={() => refetch()}
                           eventId={currentEvent?.id || -1}/>
    </>
  );
};

export default SubEvents;
